// extracted by mini-css-extract-plugin
export default {"expandableTextarea":"ExpandableTextarea_expandableTextarea__tRq8W","emptyTextArea":"ExpandableTextarea_emptyTextArea__Nbppo","charCount":"ExpandableTextarea_charCount__smRhw"};